const gameParamater = require('../define/gameParamater').default;
const object = require('../define/object').default;
const { getStageData } = require('../core/stageData').default;
const { APP_REBOOT, STAGE_INIT, PLACEMENT_BOX, DO_DAMAGES, DELETE_OBJECT, STAGE_CONTINUE, CHANGE_OBJECT } = require("./actions");
const { isInsideArea } = require('../utils').default;

// ============================
const initializeBoardPanel = () => {
    const boardArray = [];
    for (let x = 0; x < gameParamater.VERTICAL_PANEL; x++) {
        const horizontalPanels = [];
        for (let y = 0; y < gameParamater.HORIZONTAL_PANEL; y++) {
            horizontalPanels.push({
                posX: x,
                posY: y,
                object: object.OBJ_BLANK,
                hp: 0,
                mhp: 0,
                damage: 0,
                bonus: 0,
                weakness: undefined
            })
        }
        boardArray.push(horizontalPanels);
    }
    return boardArray;
}

const setBoardObject = (boardArray, posX, posY, object, hp, bonus, weakness, target, gimmickNo) => {
    if (isInsideArea(posX, posY)) {
        boardArray[posX][posY] = {
            posX, posY, object, hp, mhp: hp, damage: 0, bonus, weakness, target, gimmickNo
        };
    }
    return boardArray;
}

const setBoardObjectArray = (state, objectArray) => {
    objectArray.map(object => {
        state.boardArray = setBoardObject(state.boardArray, object.posX, object.posY, object.object, object.hp, object.bonus, object.weakness, object.target, object.gimmickNo);
    })
    return state;
}

const damageObject = (target, attackObject, damage) => {
    switch (target.object) {
        case object.OBJ_BLANK:
            break;
        case object.OBJ_BOM_BLUE:
        case object.OBJ_BOM_GREEN:
        case object.OBJ_BOM_RED:
        case object.OBJ_BOM_YELLOW:
            if (target.object === attackObject || attackObject === object.OBJ_BLANK) {
                target.hp -= damage;
                target.damage = damage;
            }
            break;
        case object.OBJ_MOB_ELVIRA:
        case object.OBJ_MOB_LOLA:
        case object.OBJ_MOB_RUDO:
        case object.OBJ_MOB_SEOHYUN:
        case object.OBJ_MOB_ZILANT:
        case object.OBJ_MOB_GARM:
        case object.OBJ_MOB_NIGHTMARE:
        case object.OBJ_MOB_GRYPHON:
            if (target.weakness && target.weakness !== attackObject) {
                damage = 1;
            }
            target.hp -= damage;
            target.damage = damage;
            break;
        case object.OBJ_TREASURE:
            if (attackObject === object.OBJ_BLANK) {
                target.hp -= damage;
                target.damage = damage;
            }
            break;
        default:
            break;
    }
    return target;
}

const setDamageArray = (state, damageArray) => {
    damageArray.map(damage => {
        if (isInsideArea(damage.posX, damage.posY)) {
            state.boardArray[damage.posX][damage.posY] = damageObject(
                state.boardArray[damage.posX][damage.posY],
                damage.attackObject,
                damage.damage
            )
        }
    })
    return state;
}

const initialState = {
    boardArray: initializeBoardPanel()
};

export function boardState(state = initialState, action) {
    // console.log(`# boardState: ${JSON.stringify(state)} -> ${JSON.stringify(action)}`);
    switch (action.type) {
        case APP_REBOOT:
            return { boardArray: initializeBoardPanel() };
        case STAGE_INIT:
            return setBoardObjectArray({ boardArray: initializeBoardPanel() }, getStageData(action.arrivalStage));
        case STAGE_CONTINUE:
            return setBoardObjectArray({ boardArray: initializeBoardPanel() }, getStageData(action.arrivalStage));
        case PLACEMENT_BOX:
            // action.objectArray: [{posX, posY, object, hp}...]
            return setBoardObjectArray({ ...state }, action.objectArray);
        case DO_DAMAGES:
            return setDamageArray({ ...state }, action.damageArray);
        case DELETE_OBJECT:
            return {
                ...state,
                boardArray: setBoardObject({ ...state }.boardArray, action.posX, action.posY, object.OBJ_BLANK, 0)
            }
        case CHANGE_OBJECT:
            return {
                ...state,
                boardArray: setBoardObject({ ...state }.boardArray, action.posX, action.posY, action.object, action.hp, action.bonus, action.weakness, action.target, action.gimmickNo)
            }
        default:
            return state;
    }
}